import { apiCall } from './gqlClient';

const GETALLORDERS_QUERY = `
  query getAllOrders($startTime: DateTime, $endTime: DateTime) {
    getAllOrders(startTime: $startTime, endTime: $endTime)
  }`;

export const getAllOrdersApiCall = async ({startTime, endTime}, ) => apiCall({ query: GETALLORDERS_QUERY, variables: {startTime, endTime}});

const GETUSERORDERS_QUERY = `
  query getUserOrders($userId: Int, $customerId: Int) {
    getUserOrders(userId: $userId, customerId: $customerId)
  }`;

export const getUserOrdersApiCall = async ({userId, customerId}, ) => apiCall({ query: GETUSERORDERS_QUERY, variables: {userId, customerId}});

const CHECKWALLETFORORDER_QUERY = `
  query checkWalletForOrder($orderId: Int!) {
    checkWalletForOrder(orderId: $orderId)
    {
      hasWallet
			balance
			charge
			enough
      ...fragments
    }
  }`;

export const checkWalletForOrderApiCall = async ({orderId}, fragments = null) => apiCall({ query: CHECKWALLETFORORDER_QUERY, variables: {orderId}, fragments });

const GETMYORDERS_QUERY = `
  query getMyOrders {
    getMyOrders
    {
      id
			userId
			customerId
			providerId
			productId
			reservationId
			subscriptionId
			userMembershipId
			bundleId
			date
			price
			paid
			stripeId
			email
			serviceId
			name
			paidWithUserMembershipId
			type
			duration
			resourceName
			startTime
			endTime
			color
			groupName
			timeUnit
			currency
			active
      ...fragments
    }
  }`;

export const getMyOrdersApiCall = async (fragments = null) => apiCall({ query: GETMYORDERS_QUERY, variables: {}, fragments });

const GETMYPENDINGORDERS_QUERY = `
  query getMyPendingOrders {
    getMyPendingOrders
    {
      id
			date
			price
			name
			type
			reservationId
			subscriptionId
			productId
      ...fragments
    }
  }`;

export const getMyPendingOrdersApiCall = async (fragments = null) => apiCall({ query: GETMYPENDINGORDERS_QUERY, variables: {}, fragments });

const GETORDEREVENTS_QUERY = `
  query getOrderEvents($orderId: Int!) {
    getOrderEvents(orderId: $orderId)
    {
      id
			orderId
			type
			price
			paid
			method
			channel
			membershipId
			walletId
			created
			stripeEventId
			amountCents
			cashFlag
			reversesEntryId
			netCents
			taxCents
			grossCents
			idempotencyKey
      ...fragments
    }
  }`;

export const getOrderEventsApiCall = async ({orderId}, fragments = null) => apiCall({ query: GETORDEREVENTS_QUERY, variables: {orderId}, fragments });

const GETORDERPAYMENTSTATE_QUERY = `
  query getOrderPaymentState($orderId: Int!) {
    getOrderPaymentState(orderId: $orderId)
    {
      totalCents
			collectedCents
			residualCents
			status
      ...fragments
    }
  }`;

export const getOrderPaymentStateApiCall = async ({orderId}, fragments = null) => apiCall({ query: GETORDERPAYMENTSTATE_QUERY, variables: {orderId}, fragments });

const GETRECEIVABLES_QUERY = `
  query getReceivables {
    getReceivables
    {
      orderId
			userId
			customerId
			customerName
			email
			date
			totalCents
			collectedCents
			residualCents
			status
      ...fragments
    }
  }`;

export const getReceivablesApiCall = async (fragments = null) => apiCall({ query: GETRECEIVABLES_QUERY, variables: {}, fragments });

const GETOVERDUEINSTALLMENTS_QUERY = `
  query getOverdueInstallments {
    getOverdueInstallments
    {
      installmentId
			orderId
			seq
			dueDate
			amountCents
			paidCents
			outstandingCents
			daysOverdue
			customerName
			email
      ...fragments
    }
  }`;

export const getOverdueInstallmentsApiCall = async (fragments = null) => apiCall({ query: GETOVERDUEINSTALLMENTS_QUERY, variables: {}, fragments });

const GETORDERBYID_QUERY = `
  query getOrderById($orderId: Int!) {
    getOrderById(orderId: $orderId)
    {
      id
			serviceId
			userMembershipId
			date
			price
			paid
			email
			name
			paidWithUserMembershipId
			type
			startTime
			endTime
			currency
			active
      ...fragments
    }
  }`;

export const getOrderByIdApiCall = async ({orderId}, fragments = null) => apiCall({ query: GETORDERBYID_QUERY, variables: {orderId}, fragments });

const PAYORDERWITHWALLET_QUERY = `
  mutation payOrderWithWallet($orderId: Int!) {
    payOrderWithWallet(orderId: $orderId)
    {
      success
			message
			id
			id2
			name
			status
      ...fragments
    }
  }`;

export const payOrderWithWalletApiCall = async ({orderId}, fragments = null) => apiCall({ query: PAYORDERWITHWALLET_QUERY, variables: {orderId}, fragments });

const CREATEORDEREVENT_QUERY = `
  mutation createOrderEvent($request: OrderEventInput!) {
    createOrderEvent(request: $request)
    {
      success
			message
			id
			id2
			name
			status
      ...fragments
    }
  }`;

export const createOrderEventApiCall = async ({request}, fragments = null) => apiCall({ query: CREATEORDEREVENT_QUERY, variables: {request}, fragments });

const CREATEINSTALLMENTPLAN_QUERY = `
  mutation createInstallmentPlan($orderId: Int!, $plan: OrderInstallmentPlanInput!) {
    createInstallmentPlan(orderId: $orderId, plan: $plan)
    {
      id
			orderId
			seq
			amountCents
			currency
			dueDate
			paidCents
			status
      ...fragments
    }
  }`;

export const createInstallmentPlanApiCall = async ({orderId, plan}, fragments = null) => apiCall({ query: CREATEINSTALLMENTPLAN_QUERY, variables: {orderId, plan}, fragments });

const MARKORDERASPAID_QUERY = `
  mutation markOrderAsPaid($id: Int!) {
    markOrderAsPaid(id: $id)
    {
      success
			message
			id
			id2
			name
			status
      ...fragments
    }
  }`;

export const markOrderAsPaidApiCall = async ({id}, fragments = null) => apiCall({ query: MARKORDERASPAID_QUERY, variables: {id}, fragments });
